import { useTranslation } from "react-i18next";

import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";

interface SearchFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  onClear?: () => void;
}

const StyledSearch = styled(TextField)({
  width: "20rem",
  "& input": {
    padding: "0.25rem 0.5rem",
  },
});

// TODO should also select all text on focus so it's easy to overwrite / reset search like this, too

const SearchField = ({ value, onChange, placeholder, onClear, ...props }: SearchFieldProps) => {
  const { t } = useTranslation();
  const handleClear = () => {
    if (onClear) {
      onClear();
    } else {
      // If no onClear handler provided, trigger onChange with empty value
      onChange({ target: { value: "" } } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <StyledSearch
      className="search-filed"
      placeholder={placeholder || t("search")}
      value={value}
      onChange={onChange}
      variant="outlined"
      slotProps={{
        input: {
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton
                aria-label={String(t("search_clear"))}
                onClick={handleClear}
                edge="end"
                size="small"
                sx={{ padding: "4px" }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      {...props}
    />
  );
};

export default SearchField;
